import MessageDetailsDrawer from "./MessageDetailsDrawer";

export default MessageDetailsDrawer;
